export default "__VITE_ASSET__DFuQcp6O__"